module.exports = __webpack_public_path__ + "static/media/email-white.8e364265.svg";